import { render, staticRenderFns } from "./subComment.vue?vue&type=template&id=6d378b02&scoped=true&"
import script from "./subComment.vue?vue&type=script&lang=js&"
export * from "./subComment.vue?vue&type=script&lang=js&"
import style0 from "./subComment.vue?vue&type=style&index=0&id=6d378b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d378b02",
  null
  
)

export default component.exports